module.exports = __webpack_public_path__ + "static/media/carta_81.6cd50452.jpg";